<template>
    <div class="signup container">
        <div class="card">
            <div class="form-wrapper card-content">
                <form @submit.prevent="signup">
                    <h2 class="title">Signup</h2>
                    <div class="field">
                        <label for="email">Email:</label>
                        <input type="email" name="email" v-model="email">
                    </div>
                    <div class="field">
                        <label for="password">Password:</label>
                        <input type="password" name="password" v-model="password">
                    </div>
                    <div class="field input last">
                        <label for="alias">Alias:</label>
                        <input type="text" name="alias" v-model="alias">
                    </div>
                    <div class="field center-align">
                        <p class="feedback error-light" v-if="feedback">
                            {{ feedback }}
                        </p>
                        <button class="btn-submit btn">Signup</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase'
import db from '@/firebase/init'

export default {
    name: 'Signup',
    data() {
        return {
            email: null,
            password: null,
            alias: null,
            feedback: null
        }
    },
    methods: {
        signup() {
            if (this.alias && this.email && this.password) {

                // if not create a new user with email and password and store it to firebase authentication
                firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
                // after data is completly loaded get acces to firebase authentication credentials (Anmeldedaten)
                .then(cred => {
                    // and set a new user to firebase databse
                    db.collection('users').doc(cred.user.uid).set({
                        alias: this.alias,
                        email: this.email,
                        // save unique user id from credentials (cred.user.uid) to users id in firebase database
                        favorites: {},
                        user_id: cred.user.uid
                    })
                })
                // after new user is set redirect to route Gmap
                .then(() => {
                    this.$router.push({ name: 'Index' })
                })
                // if something doesn't work show error
                .catch(err => {
                    console.log(err);
                    this.feedback = err.message
                })
                this.feedback = "This alias is free to use"
            }

            else {
                this.feedback = 'You must enter all fields'
            }
        }
    }
}

</script>

<style lang="scss">

    .signup {
        max-width: 400px;
        margin-top: 60px;

        .title {
            font-size: 1.4em;
            color: #fff;
        }

        .field.input.last {
            margin-bottom: 40px;
        }

        .feedback {
            margin-bottom: 1rem !important;

            &.error-light {
                color: #c2f9ff;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/auth/Signup.vue